import * as WindowsAzure from "azure-mobile-apps-client";

export default new WindowsAzure.MobileServiceClient(
    window.location.hostname === "localhost"
        ? "http://localhost:3001"
        : window.location.href.substring(0, window.location.href.split('?')[0].lastIndexOf("/"))
);
